import { render, staticRenderFns } from "./facePassInfo.vue?vue&type=template&id=9269cda4"
import script from "./facePassInfo.vue?vue&type=script&lang=js"
export * from "./facePassInfo.vue?vue&type=script&lang=js"
import style0 from "./facePassInfo.vue?vue&type=style&index=0&id=9269cda4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports